import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MaterialInput from "@Shared/components/inputs/material-input";
import Select2 from "@Shared/components/inputs/select2";
import { useMultipleSelect } from "@Shared/@Composables/generic/useMultipleSelect";
import SelectEmail from "@Broker/@HandlebarsTemplates/clients/board/_select-email.hbs";
import { isEmpty, startCase } from "lodash";
import { email } from "vuelidate/lib/validators";
export default {
  name: "SelectEmailField",
  components: {
    MaterialInput,
    Select2
  },
  props: {
    value: {
      type: [String, Array],
      required: true
    },
    emailList: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ""
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    allowCreate: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    toList: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    selectOptions() {
      return {
        placeholder: this.label,
        templateResult: this.formatResult,
        multiple: this.multiple,
        tags: this.allowCreate,
        createTag: function (params) {
          var _context;
          var term = _trimInstanceProperty(_context = params.term).call(_context);
          if (term === "") {
            return null;
          }
          return {
            id: term,
            text: term,
            title: term,
            disabled: !email(term)
          };
        }
      };
    },
    computedLabel() {
      return isEmpty(this.value) ? "" : this.label;
    }
  },
  methods: {
    formatData(data) {
      return data && _mapInstanceProperty(data).call(data, item => {
        return {
          title: startCase(`${item.givenName} ${item.familyName}`),
          description: item.email,
          text: item.email,
          id: item.email
        };
      });
    },
    formatResult(state) {
      return $(SelectEmail(_objectSpread(_objectSpread({}, state), {}, {
        description: state.description || this.$t("client-profile.messages.otherEmail")
      })));
    },
    handleChange(selectedValue, type) {
      const {
        handleSelectMultipleChange
      } = useMultipleSelect();
      this.toList = handleSelectMultipleChange(selectedValue, type, this.toList, this.multiple);
    }
  }
};